var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect0, _rect1, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15, _rect16, _rect17, _rect18;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconLayoutx5(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 3,
    height: 4,
    rx: 1
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    width: 3,
    height: 4,
    rx: 1
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 8,
    width: 3,
    height: 4,
    rx: 1
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 12,
    width: 3,
    height: 4,
    rx: 1
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 16,
    width: 3,
    height: 4,
    rx: 1
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    y: 5,
    width: 3,
    height: 4,
    rx: 1
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 5,
    width: 3,
    height: 4,
    rx: 1
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 5,
    width: 3,
    height: 4,
    rx: 1
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 5,
    width: 3,
    height: 4,
    rx: 1
  })), _rect0 || (_rect0 = /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 5,
    width: 3,
    height: 4,
    rx: 1
  })), _rect1 || (_rect1 = /*#__PURE__*/React.createElement("rect", {
    y: 10,
    width: 3,
    height: 4,
    rx: 1
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 10,
    width: 3,
    height: 4,
    rx: 1
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 10,
    width: 3,
    height: 4,
    rx: 1
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 10,
    width: 3,
    height: 4,
    rx: 1
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 10,
    width: 3,
    height: 4,
    rx: 1
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    y: 15,
    width: 3,
    height: 4,
    rx: 1
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 15,
    width: 3,
    height: 4,
    rx: 1
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 15,
    width: 3,
    height: 4,
    rx: 1
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 15,
    width: 3,
    height: 4,
    rx: 1
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 15,
    width: 3,
    height: 4,
    rx: 1
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLayoutx5);
export default __webpack_public_path__ + "static/media/icon-layoutx5.f82e51f97d7cc946c21df095c533b7a4.svg";
export { ForwardRef as ReactComponent };